import {Component, Input, OnInit} from '@angular/core';
import {BwAvailabilityService} from '../../../services/bwAvailability.service';
import {escapeHtml, ServiceMapPopup, serviceMapBlock, serviceMapRow} from '../service-map/service-map.component';

@Component({
  selector: 'app-bw-service-map',
  templateUrl: './bw-service-map.component.html'
})
export class BwServiceMapComponent implements OnInit {

  @Input() commercialPopList = [];
  productsList: { [trigram: string]: any } = {};
  loading = true;
  error = false;

  constructor(private bwAvailabilityService: BwAvailabilityService) {
  }

  ngOnInit() {
    this.bwAvailabilityService.getBwAvailabilitiesForMap().subscribe({
      next: res => {
        this.productsList = res as any;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }

  buildPopup = (pop: any, entry: any): ServiceMapPopup => {
    const productNames = Object.keys(entry || {});
    const blocks = productNames.map(productName => {
      const rows: string[] = [];
      const reception = entry[productName]['reception'];
      const injection = entry[productName]['injection'];
      if (reception && reception.length) {
        rows.push(serviceMapRow('Reception', this.buildFlow([pop.displayId], reception)));
      }
      if (injection && injection.length) {
        rows.push(serviceMapRow('Injection', this.buildFlow(injection, [pop.displayId])));
      }
      return serviceMapBlock(productName, rows);
    });

    return {
      count: productNames.length,
      countLabel: 'product',
      body: blocks.join('')
    };
  }

  private buildFlow(from: string[], to: string[]): string {
    return `${escapeHtml(from.join(', '))} <span class="smp-arrow">&rarr;</span> ${escapeHtml(to.join(', '))}`;
  }
}
